import * as React from 'react';
const SvgScrollDown = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='m10 14.156 3.56-3.57a.54.54 0 0 1 .388-.172q.215 0 .387.173.18.18.181.387 0 .205-.181.387l-3.87 3.87a.64.64 0 0 1-.465.193.66.66 0 0 1-.465-.193l-3.87-3.87a.5.5 0 0 1-.162-.387.58.58 0 0 1 .183-.387q.18-.18.387-.181.205 0 .387.18zm0-5.922 3.56-3.569a.54.54 0 0 1 .388-.173q.215 0 .387.173.18.181.181.388 0 .206-.181.387l-3.87 3.87a.64.64 0 0 1-.465.192.66.66 0 0 1-.465-.192l-3.87-3.87a.5.5 0 0 1-.162-.388.58.58 0 0 1 .183-.387q.18-.18.387-.18.205 0 .387.18z'
            />
        </g>
    </svg>
);
export default SvgScrollDown;
